import { createNode } from '@glueapp/graph-types';

export const ParseBearerToken = createNode({
    id: 'ParseBearerToken',
    name: 'Parse Bearer Token',
    description: 'Extract a Bearer token from an Authorization header',
    category: 'API Server',
    color: '#808080',
    inPorts: {
        Authorization: { kind: 'string' },
    },
    outPorts: {
        Token: { kind: 'string' },
    },
    execute: input => {
        const authorization = input.inPorts.Authorization as string | null;

        if (!authorization || typeof authorization !== 'string') {
            return { output: { Token: '' } };
        }

        const trimmed = authorization.trim();
        if (!trimmed.toLowerCase().startsWith('bearer ')) {
            return { output: { Token: '' } };
        }

        const token = trimmed.slice(7).trim();

        return { output: { Token: token } };
    },
});
